// S1000D Information Codes — complete set extracted from InfoCodes.pdf
// Excludes codes marked "Not available for projects"

export const INFO_CODES = [
  // 000 series — General & Reference
  { code: "000", name: "Function, data for plans and description" },
  { code: "001", name: "Title page" },
  { code: "002", name: "List of pages or data modules" },
  { code: "003", name: "Change record or highlights" },
  { code: "004", name: "Access illustration" },
  { code: "005", name: "List of abbreviations" },
  { code: "006", name: "List of terms" },
  { code: "007", name: "List of symbols" },
  { code: "008", name: "Technical standard record" },
  { code: "009", name: "Table of contents" },
  { code: "010", name: "General data" },
  { code: "011", name: "Function" },
  { code: "012", name: "General warnings and cautions and related safety data" },
  { code: "013", name: "Numeric index" },
  { code: "014", name: "Alphabetic and alphanumeric index" },
  { code: "015", name: "List of special materials" },
  { code: "016", name: "List of dangerous materials" },
  { code: "017", name: "List of related data" },
  { code: "018", name: "Introduction" },
  { code: "019", name: "Supplier list" },
  { code: "020", name: "Configuration" },
  { code: "021", name: "Copyright" },
  { code: "022", name: "Business rules exchange" },
  { code: "023", name: "Administrative forms and data" },
  { code: "024", name: "Business rules" },
  { code: "025", name: "Export control policy" },
  { code: "026", name: "Regulatory policy" },
  { code: "028", name: "General" },
  { code: "029", name: "Data structure" },
  { code: "030", name: "Technical data" },
  { code: "031", name: "Electrical standard parts data" },
  { code: "033", name: "Technical data (functional breakdown)" },
  { code: "034", name: "Technical data (physical breakdown)" },
  { code: "040", name: "Description" },
  { code: "041", name: "Description of how it is made" },
  { code: "042", name: "Description of function" },
  { code: "043", name: "Description of function attributed to crew (functional breakdown)" },
  { code: "044", name: "Description of function (physical breakdown)" },
  { code: "045", name: "Designated use" },
  { code: "046", name: "Dependence on peripheral systems/equipment" },
  { code: "050", name: "Diagram/List" },
  { code: "051", name: "Wiring diagram" },
  { code: "052", name: "Routing diagram" },
  { code: "053", name: "Connection list" },
  { code: "054", name: "Schematic diagram" },
  { code: "055", name: "Location diagram" },
  { code: "056", name: "Equipment list" },
  { code: "057", name: "Wire list" },
  { code: "058", name: "Harness list" },
  { code: "059", name: "Maintenance envelope diagram" },
  { code: "060", name: "Product support equipment, tools and software" },
  { code: "061", name: "Special support equipment and tools" },
  { code: "062", name: "Standard support equipment and tools" },
  { code: "063", name: "Government supplied support equipment and tools" },
  { code: "064", name: "Locally made support equipment and tools" },
  { code: "065", name: "Software" },
  { code: "066", name: "Support equipment and tools data" },
  { code: "067", name: "Decals and instruction plates" },
  { code: "070", name: "Consumables, materials and expendables" },
  { code: "071", name: "Consumables" },
  { code: "072", name: "Materials" },
  { code: "073", name: "Expendables" },
  { code: "074", name: "Data sheet for dangerous consumables and materials" },
  { code: "075", name: "Parts list" },
  { code: "076", name: "Fluid" },
  { code: "077", name: "Data sheet for consumables and materials" },
  { code: "078", name: "Fasteners" },
  { code: "080", name: "Mixture and solution" },
  { code: "081", name: "Chemical solution" },
  { code: "082", name: "Chemical mixture" },
  { code: "090", name: "Software documentation" },
  { code: "096", name: "Safety critical items and parts" },
  // 00x letter codes
  { code: "00A", name: "List of illustrations" },
  { code: "00B", name: "List of support equipment" },
  { code: "00C", name: "List of supplies" },
  { code: "00D", name: "List of spares" },
  { code: "00E", name: "Functional item numbers common information repository" },
  { code: "00F", name: "Circuit breakers common information repository" },
  { code: "00G", name: "Parts common information repository" },
  { code: "00H", name: "Zones common information repository" },
  { code: "00J", name: "Access panels and doors common information repository" },
  { code: "00K", name: "Organizations common information repository" },
  { code: "00L", name: "Supplies - List of products common information repository" },
  { code: "00M", name: "Supplies - List of requirements common information repository" },
  { code: "00N", name: "Support equipment common information repository" },
  { code: "00P", name: "Product Cross-reference Table (PCT)" },
  { code: "00Q", name: "Conditions Cross-reference Table (CCT)" },
  { code: "00R", name: "List of effective pages" },
  { code: "00S", name: "List of effective data modules" },
  { code: "00T", name: "Change record" },
  { code: "00U", name: "Highlights" },
  { code: "00V", name: "List of applicable specifications and documentation" },
  { code: "00W", name: "Applicability Cross-reference Table (ACT)" },
  { code: "00X", name: "Controls and indicators common information repository" },
  { code: "00Y", name: "List of charts and forms" },
  { code: "00Z", name: "List of tables" },
  // 0Ax codes
  { code: "0A1", name: "Functional and/or physical areas repository" },
  { code: "0A2", name: "Applicability repository" },
  { code: "0A3", name: "Applicability cross-reference table catalog" },
  { code: "0A4", name: "Warnings - List of warnings in the common information repository" },
  { code: "0A5", name: "Cautions - List of cautions in the common information repository" },
  // 0Bx codes — Maintenance planning
  { code: "0B0", name: "Maintenance planning information" },
  { code: "0B1", name: "Time limits" },
  { code: "0B2", name: "System maintenance/inspection tasks list" },
  { code: "0B3", name: "Structure maintenance/inspection tasks list" },
  { code: "0B4", name: "Zonal maintenance/inspection tasks list" },
  { code: "0B5", name: "Unscheduled check" },
  // 100 series — Operation
  { code: "100", name: "Operation" },
  { code: "101", name: "List of consumables associated with operation" },
  { code: "102", name: "List of materials associated with operation" },
  { code: "103", name: "List of expendables associated with operation" },
  { code: "104", name: "List of special support equipment and tools associated with operation" },
  { code: "105", name: "List of support equipment and tools associated with operation" },
  { code: "106", name: "List of software associated with operation" },
  { code: "107", name: "Parts list associated with operation" },
  { code: "110", name: "Controls and indicators" },
  { code: "111", name: "Controls and indicators" },
  { code: "112", name: "Modes of operation" },
  { code: "115", name: "Displays and alerts" },
  { code: "120", name: "Pre-operation" },
  { code: "121", name: "Pre-operation procedure" },
  { code: "122", name: "Siting" },
  { code: "123", name: "Shelter" },
  { code: "125", name: "Pre-operation procedures checklist" },
  { code: "126", name: "Conditions of readiness" },
  { code: "127", name: "Establish operating position" },
  { code: "130", name: "Normal operation" },
  { code: "131", name: "Normal operation procedure" },
  { code: "132", name: "Start-up procedure for maintenance" },
  { code: "133", name: "Shutdown procedure for maintenance" },
  { code: "134", name: "Aviation checklist" },
  { code: "135", name: "Normal operation procedures checklist" },
  { code: "136", name: "Ground running check" },
  { code: "138", name: "Ground running performance adjustment" },
  { code: "139", name: "Nuclear, biological and chemical procedures" },
  { code: "140", name: "Emergency procedure" },
  { code: "141", name: "Emergency operation procedure" },
  { code: "142", name: "Operation under unusual conditions" },
  { code: "143", name: "Radio interference suppression" },
  { code: "144", name: "Jamming and electronic countermeasures (ECM)" },
  { code: "145", name: "Emergency operation procedures checklist" },
  { code: "146", name: "Emergency shutdown operation procedure" },
  { code: "150", name: "Post-operation" },
  { code: "151", name: "Post-operation procedure" },
  { code: "155", name: "Post-operation procedures checklist" },
  { code: "157", name: "Establish maintenance position" },
  { code: "160", name: "Loading/Unloading procedure" },
  { code: "161", name: "Special operation" },
  { code: "162", name: "Non-tactical operation" },
  { code: "169", name: "Mass and balance" },
  { code: "170", name: "Handling" },
  { code: "171", name: "Lifting" },
  { code: "172", name: "Jacking" },
  { code: "173", name: "Shoring" },
  { code: "174", name: "Towing" },
  { code: "175", name: "Taxiing" },
  { code: "176", name: "Lowering" },
  { code: "177", name: "Stabilizing" },
  { code: "178", name: "Tethering" },
  { code: "179", name: "Debogging" },
  { code: "180", name: "Dispatch deviation" },
  { code: "181", name: "Deactivate for dispatch deviation" },
  // 200 series — Servicing
  { code: "200", name: "Servicing" },
  { code: "201", name: "List of consumables associated with servicing" },
  { code: "202", name: "List of materials associated with servicing" },
  { code: "203", name: "List of expendables associated with servicing" },
  { code: "204", name: "List of special support equipment and tools associated with servicing" },
  { code: "205", name: "List of support equipment and tools associated with servicing" },
  { code: "206", name: "List of software associated with servicing" },
  { code: "207", name: "Parts list associated with servicing" },
  { code: "210", name: "Fill" },
  { code: "211", name: "Refuel" },
  { code: "212", name: "Fill with oil" },
  { code: "213", name: "Fill with oxygen" },
  { code: "214", name: "Fill with nitrogen" },
  { code: "215", name: "Fill with air" },
  { code: "216", name: "Fill with water" },
  { code: "217", name: "Fill with hydrogen" },
  { code: "218", name: "Fill with other liquid" },
  { code: "219", name: "Fill with other gas" },
  { code: "220", name: "Drain liquid and release pressure" },
  { code: "221", name: "Defuel and drain fuel" },
  { code: "222", name: "Drain oil" },
  { code: "223", name: "Release oxygen pressure" },
  { code: "224", name: "Release nitrogen pressure" },
  { code: "225", name: "Release air pressure" },
  { code: "226", name: "Drain water" },
  { code: "227", name: "Release hydrogen pressure" },
  { code: "228", name: "Drain other liquid" },
  { code: "229", name: "Release other gas pressure" },
  { code: "230", name: "Bleed and prime" },
  { code: "231", name: "Bleed" },
  { code: "232", name: "Prime" },
  { code: "233", name: "Dry" },
  { code: "234", name: "Facility requirements associated with servicing" },
  { code: "235", name: "Flush" },
  { code: "236", name: "Fill with inert gas/inert liquid" },
  { code: "237", name: "Evacuate" },
  { code: "240", name: "Lubrication" },
  { code: "241", name: "Oil" },
  { code: "242", name: "Grease" },
  { code: "243", name: "Dry film" },
  { code: "250", name: "Clean and apply surface protection" },
  { code: "251", name: "Clean with chemical agent" },
  { code: "252", name: "Clean by abrasive blast" },
  { code: "253", name: "Clean by ultrasonics" },
  { code: "254", name: "Clean mechanically" },
  { code: "255", name: "Purge" },
  { code: "256", name: "Polish and apply wax" },
  { code: "257", name: "Paint and apply marking" },
  { code: "258", name: "Other procedure to clean" },
  { code: "259", name: "Other procedure to protect surfaces" },
  { code: "260", name: "Remove and prevent ice and remove contamination" },
  { code: "261", name: "Remove ice" },
  { code: "262", name: "Prevent ice" },
  { code: "263", name: "Use disinfectant/Sanitize" },
  { code: "264", name: "Remove contamination" },
  { code: "270", name: "Adjust, align and calibrate" },
  { code: "271", name: "Adjust" },
  { code: "272", name: "Align" },
  { code: "273", name: "Calibrate" },
  { code: "274", name: "Harmonize" },
  { code: "275", name: "Grooming" },
  { code: "276", name: "Rig" },
  { code: "277", name: "Compensate" },
  { code: "278", name: "Easily and quickly adjust after a battle damage repair" },
  { code: "279", name: "Easily and quickly align after a battle damage repair" },
  { code: "280", name: "Inspection" },
  { code: "281", name: "Scheduled inspection" },
  { code: "282", name: "Unscheduled inspection" },
  { code: "283", name: "Special regular inspection" },
  { code: "284", name: "Special irregular inspection" },
  { code: "285", name: "Structure inspection for allowable damage limits" },
  { code: "286", name: "Structure inspection for repair" },
  { code: "288", name: "Overhaul and retirement schedule" },
  { code: "289", name: "Check filling quantity" },
  { code: "290", name: "Change of liquid/gas" },
  { code: "292", name: "Change of oil" },
  { code: "293", name: "Change of oxygen" },
  { code: "294", name: "Change of nitrogen" },
  { code: "295", name: "Change of air" },
  { code: "296", name: "Change of water" },
  { code: "297", name: "Change of hydrogen" },
  { code: "298", name: "Change of other liquid" },
  { code: "299", name: "Change of other gas" },
  // 300 series — Examinations, tests and checks
  { code: "300", name: "Examinations, tests and checks" },
  { code: "301", name: "List of consumables associated with examinations, tests and checks" },
  { code: "302", name: "List of materials associated with examinations, tests and checks" },
  { code: "303", name: "List of expendables associated with examinations, tests and checks" },
  { code: "304", name: "List of special support equipment and tools associated with examinations, tests and checks" },
  { code: "305", name: "List of support equipment and tools associated with examinations, tests and checks" },
  { code: "306", name: "List of software associated with examinations, tests and checks" },
  { code: "307", name: "Parts list associated with examinations, tests and checks" },
  { code: "310", name: "Visual examination" },
  { code: "311", name: "Visual examination without special equipment" },
  { code: "312", name: "Examination with a borescope" },
  { code: "315", name: "QA requirements" },
  { code: "320", name: "Operation test" },
  { code: "321", name: "Unit break-in" },
  { code: "322", name: "Test and inspection" },
  { code: "330", name: "Test preparation" },
  { code: "331", name: "Connection of test equipment" },
  { code: "332", name: "Removal of test equipment" },
  { code: "333", name: "Installation of the unit before the test" },
  { code: "334", name: "Removal of the unit after the test" },
  { code: "335", name: "Final measures" },
  { code: "340", name: "Function test" },
  { code: "341", name: "Manual test" },
  { code: "342", name: "Automatic test" },
  { code: "343", name: "BIT" },
  { code: "344", name: "Compatibility test" },
  { code: "345", name: "System test" },
  { code: "346", name: "Other check" },
  { code: "347", name: "Start-up procedure for test" },
  { code: "348", name: "Final acceptance test (FAT)" },
  { code: "349", name: "Test records" },
  { code: "350", name: "Structure test" },
  { code: "351", name: "Test for surface cracks with dye penetrant" },
  { code: "352", name: "Test for surface cracks with magnetic particles" },
  { code: "353", name: "Test for cracks and other defects with eddy current" },
  { code: "354", name: "Test for cracks and other defects with X-rays" },
  { code: "355", name: "Test for cracks and other defects with ultrasonics" },
  { code: "356", name: "Hardness test" },
  { code: "357", name: "Gamma-ray test" },
  { code: "358", name: "Resonance frequency test" },
  { code: "359", name: "Thermographic test" },
  { code: "360", name: "Design data/tolerances check" },
  { code: "361", name: "Dimensions check" },
  { code: "362", name: "Pressure check" },
  { code: "363", name: "Flow check" },
  { code: "364", name: "Leak check" },
  { code: "365", name: "Continuity check" },
  { code: "366", name: "Resistance check" },
  { code: "367", name: "Electrical power check" },
  { code: "368", name: "Signal strength check" },
  { code: "369", name: "Other check" },
  { code: "370", name: "Monitor the condition" },
  { code: "371", name: "Oil analysis" },
  { code: "372", name: "Vibration analysis" },
  { code: "373", name: "Tracking check" },
  { code: "374", name: "Fuel analysis" },
  { code: "375", name: "Shooting accidental discharge analysis" },
  { code: "376", name: "Check post application of adhesive" },
  { code: "377", name: "Contamination analysis" },
  { code: "390", name: "Sample test" },
  { code: "396", name: "Flight control surface movement" },
  { code: "397", name: "Landing gear movement" },
  { code: "398", name: "Product configuration" },
  // 400 series — Fault reports and isolation procedures
  { code: "400", name: "Fault reports and isolation procedures" },
  { code: "401", name: "List of consumables associated with fault diagnosis" },
  { code: "402", name: "List of materials associated with fault diagnosis" },
  { code: "403", name: "List of expendables associated with fault diagnosis" },
  { code: "404", name: "List of special support equipment and tools associated with fault diagnosis" },
  { code: "405", name: "List of support equipment and tools associated with fault diagnosis" },
  { code: "406", name: "List of software associated with fault diagnosis" },
  { code: "407", name: "Parts list associated with fault diagnosis" },
  { code: "410", name: "General fault description" },
  { code: "411", name: "Isolated fault" },
  { code: "412", name: "Detected fault" },
  { code: "413", name: "Observed fault" },
  { code: "414", name: "Correlated fault" },
  { code: "415", name: "Impact of fault" },
  { code: "420", name: "General fault isolation procedure" },
  { code: "421", name: "Fault isolation procedure" },
  { code: "422", name: "Fault isolation procedure" },
  { code: "423", name: "Fault isolation procedure" },
  { code: "424", name: "Fault isolation procedure" },
  { code: "425", name: "Fault isolation procedure" },
  { code: "426", name: "Fault isolation procedure" },
  { code: "427", name: "Fault isolation procedure" },
  { code: "428", name: "Fault isolation procedure" },
  { code: "429", name: "Diagnostics" },
  { code: "430", name: "Fault isolation task supporting data" },
  { code: "440", name: "Index" },
  { code: "441", name: "Fault code index" },
  { code: "442", name: "Maintenance message index" },
  { code: "443", name: "Post-troubleshooting shutdown procedure" },
  // 500 series — Disconnect, remove and disassemble
  { code: "500", name: "Disconnect, remove and disassemble procedures" },
  { code: "501", name: "List of consumables associated with removal" },
  { code: "502", name: "List of materials associated with removal" },
  { code: "503", name: "List of expendables associated with removal" },
  { code: "504", name: "List of special support equipment and tools associated with removal" },
  { code: "505", name: "List of support equipment and tools associated with removal" },
  { code: "506", name: "List of software associated with removal" },
  { code: "507", name: "Parts list associated with removal" },
  { code: "510", name: "Disconnect procedure" },
  { code: "520", name: "Remove procedure" },
  { code: "521", name: "Return to basic configuration" },
  { code: "522", name: "Remove support equipment/Remove from support equipment" },
  { code: "523", name: "Preparation before removal" },
  { code: "524", name: "Follow-on maintenance" },
  { code: "525", name: "Ammunition unloading" },
  { code: "526", name: "Deactivate launching device" },
  { code: "530", name: "Disassemble procedure" },
  { code: "531", name: "Disassemble on operation site" },
  { code: "540", name: "Open for access procedure" },
  { code: "550", name: "Unload software procedure" },
  { code: "551", name: "Fault monitoring storage readout (downloading)" },
  { code: "552", name: "Data erasing" },
  { code: "553", name: "Display, copy and print of data" },
  { code: "560", name: "Deactivation procedure" },
  { code: "561", name: "De-energize electrical network" },
  { code: "562", name: "Depressurize hydraulics" },
  { code: "563", name: "Deactivation maintenance practice" },
  // 600 series — Repairs and locally make procedures
  { code: "600", name: "Repairs and locally make procedures and data" },
  { code: "601", name: "List of consumables associated with repairs" },
  { code: "602", name: "List of materials associated with repairs" },
  { code: "603", name: "List of expendables associated with repairs" },
  { code: "604", name: "List of special support equipment and tools associated with repairs" },
  { code: "605", name: "List of support equipment and tools associated with repairs" },
  { code: "606", name: "List of software associated with repairs" },
  { code: "607", name: "Parts list associated with repairs" },
  { code: "610", name: "Add material" },
  { code: "611", name: "Insulation" },
  { code: "612", name: "Metalize" },
  { code: "613", name: "Pot" },
  { code: "614", name: "Remetal" },
  { code: "615", name: "Retread" },
  { code: "620", name: "Attach material" },
  { code: "621", name: "Bond" },
  { code: "622", name: "Crimp" },
  { code: "623", name: "Braze" },
  { code: "624", name: "Rivet" },
  { code: "625", name: "Solder" },
  { code: "626", name: "Splice" },
  { code: "627", name: "Weld" },
  { code: "630", name: "Change the mechanical strength/structure of material" },
  { code: "631", name: "Anneal" },
  { code: "632", name: "Case harden" },
  { code: "633", name: "Cure" },
  { code: "634", name: "Normalize" },
  { code: "635", name: "Shot-peen" },
  { code: "636", name: "Temper" },
  { code: "638", name: "Other treatment" },
  { code: "639", name: "Other process to change the mechanical strength/structure of material" },
  { code: "640", name: "Change the surface finish of material" },
  { code: "641", name: "Anodize" },
  { code: "642", name: "Buff" },
  { code: "643", name: "Burnish" },
  { code: "644", name: "Chromate" },
  { code: "645", name: "Hone" },
  { code: "646", name: "Lap" },
  { code: "647", name: "Plate" },
  { code: "648", name: "Polish" },
  { code: "649", name: "Cleanup of dents, cracks and scratches" },
  { code: "650", name: "Remove material" },
  { code: "651", name: "Abrasive blast" },
  { code: "652", name: "Bore/drill/ream" },
  { code: "653", name: "Electrical/electrochemical/chemical etch" },
  { code: "654", name: "Broach" },
  { code: "655", name: "Grind" },
  { code: "656", name: "Mill" },
  { code: "657", name: "Thread/tap" },
  { code: "658", name: "Turn" },
  { code: "659", name: "Other process to remove material" },
  { code: "660", name: "Structure repair procedure and data" },
  { code: "661", name: "Allowable damage" },
  { code: "662", name: "Temporary repair procedure" },
  { code: "663", name: "Standard repair procedure" },
  { code: "664", name: "Special repair procedure" },
  { code: "665", name: "Fly-in repair procedure" },
  { code: "666", name: "Material classification" },
  { code: "667", name: "Structure classification" },
  { code: "668", name: "Allowable damage of composite structures" },
  { code: "669", name: "Allowable damage of mixed structures" },
  { code: "670", name: "Locally make procedure and data" },
  { code: "671", name: "Making of parts" },
  { code: "680", name: "Battle damage repair procedure and data" },
  { code: "681", name: "Damage repair symbol marking" },
  { code: "682", name: "Identification of damaged hardware" },
  { code: "683", name: "Damage assessment" },
  { code: "684", name: "Utilization degradation" },
  { code: "685", name: "Repair procedure" },
  { code: "686", name: "Isolation procedure" },
  { code: "687", name: "Function test after battle damage repair" },
  { code: "688", name: "Battle damage repair kit" },
  { code: "689", name: "Damage repair" },
  { code: "690", name: "Miscellaneous" },
  { code: "691", name: "Marking" },
  { code: "692", name: "Connector repair" },
  { code: "693", name: "Varnish" },
  // 700 series — Assemble, install and connect
  { code: "700", name: "Assemble, install and connect procedures" },
  { code: "701", name: "List of consumables associated with installation" },
  { code: "702", name: "List of materials associated with installation" },
  { code: "703", name: "List of expendables associated with installation" },
  { code: "704", name: "List of special support equipment and tools associated with installation" },
  { code: "705", name: "List of support equipment and tools associated with installation" },
  { code: "706", name: "List of software associated with installation" },
  { code: "707", name: "Parts list associated with installation" },
  { code: "710", name: "Assemble procedure" },
  { code: "711", name: "Tighten procedure" },
  { code: "712", name: "Lock procedure" },
  { code: "713", name: "Pack procedure" },
  { code: "714", name: "Assemble on operation site" },
  { code: "720", name: "Install procedure" },
  { code: "721", name: "Build up to usable configuration" },
  { code: "722", name: "Install support equipment/Install on support equipment" },
  { code: "723", name: "Preparation before installation" },
  { code: "724", name: "Follow-on maintenance" },
  { code: "725", name: "Ammunition loading" },
  { code: "726", name: "Activate launching device" },
  { code: "727", name: "Site location plans" },
  { code: "728", name: "Foundation preparation" },
  { code: "730", name: "Connect procedure" },
  { code: "740", name: "Close after access procedure" },
  { code: "750", name: "Load software procedure" },
  { code: "752", name: "Data loading" },
  { code: "760", name: "Reactivation procedure" },
  { code: "761", name: "Energize electrical network" },
  { code: "762", name: "Pressurize hydraulics" },
  // 800 series — Package, handling, storage and transportation
  { code: "800", name: "Package, handling, storage and transportation" },
  { code: "801", name: "List of consumables associated with storage" },
  { code: "802", name: "List of materials associated with storage" },
  { code: "803", name: "List of expendables associated with storage" },
  { code: "804", name: "List of special support equipment and tools associated with storage" },
  { code: "805", name: "List of support equipment and tools associated with storage" },
  { code: "806", name: "List of software associated with storage" },
  { code: "807", name: "Parts list associated with storage" },
  { code: "810", name: "Preservation procedure" },
  { code: "811", name: "Preparation for vehicle transportation" },
  { code: "812", name: "Shipping and storage - General" },
  { code: "820", name: "Procedure to remove preservation material" },
  { code: "830", name: "Procedure to put item in containers" },
  { code: "831", name: "Vehicle loading" },
  { code: "832", name: "Procedure to pack items" },
  { code: "840", name: "Procedure to remove item from containers" },
  { code: "841", name: "Vehicle unloading" },
  { code: "842", name: "Procedure to unpack items" },
  { code: "850", name: "Procedure to keep item serviceable when in storage" },
  { code: "860", name: "Procedure to move item when in storage" },
  { code: "870", name: "Procedure to prepare item for use after storage" },
  { code: "871", name: "Set on condition" },
  { code: "880", name: "Procedure when item got out of storage" },
  { code: "890", name: "Life data of item when in storage" },
  // 900 series — Miscellaneous
  { code: "900", name: "Miscellaneous" },
  { code: "901", name: "Miscellaneous list of consumables" },
  { code: "902", name: "Miscellaneous list of materials" },
  { code: "903", name: "Miscellaneous list of expendables" },
  { code: "904", name: "Miscellaneous list of special support equipment and tools" },
  { code: "905", name: "Miscellaneous list of support equipment and tools" },
  { code: "906", name: "Miscellaneous list of software" },
  { code: "907", name: "Miscellaneous parts list" },
  { code: "910", name: "Miscellaneous" },
  { code: "911", name: "Illustration" },
  { code: "912", name: "Handling procedure" },
  { code: "913", name: "General maintenance procedure" },
  { code: "914", name: "Container data module" },
  { code: "915", name: "Facilities" },
  { code: "916", name: "Maintenance allocation" },
  { code: "917", name: "Non-S1000D publication" },
  { code: "920", name: "Change = Remove and install" },
  { code: "921", name: "Change = Remove and install a new item" },
  { code: "922", name: "Change = Remove and install the removed item" },
  { code: "923", name: "Change = Disconnect and connect an item" },
  { code: "930", name: "Service bulletin" },
  { code: "931", name: "Service bulletin data" },
  { code: "932", name: "Planning information" },
  { code: "933", name: "Accomplishment procedure - Task set" },
  { code: "934", name: "Material information" },
  { code: "940", name: "Provisioning data" },
  { code: "941", name: "Illustrated parts data" },
  { code: "942", name: "Numerical index" },
  { code: "950", name: "Composite information" },
  { code: "951", name: "Generic process" },
  { code: "952", name: "Generic learning content" },
  { code: "961", name: "Calculation worksheets" },
  { code: "970", name: "Approved vendor processes" },
  { code: "980", name: "Environmental protection, fire-fighting and rescue" },
  { code: "981", name: "Air cleaning" },
  { code: "982", name: "Sewage treatment" },
  { code: "989", name: "Fire-fighting and rescue" },
  { code: "990", name: "Neutralization and disposal" },
  { code: "991", name: "Neutralization of ordnance" },
  { code: "992", name: "Neutralization of substance" },
  { code: "996", name: "Disposal of ordnance" },
  { code: "997", name: "Disposal of Product" },
  { code: "998", name: "Disposal of substance" },
  // C00 series — Computer systems, software and data
  { code: "C00", name: "Computer systems, software and data" },
  { code: "C01", name: "List of consumables associated with computer systems" },
  { code: "C02", name: "List of materials associated with computer systems" },
  { code: "C03", name: "List of expendables associated with computer systems" },
  { code: "C04", name: "List of special support equipment and tools associated with computer systems" },
  { code: "C05", name: "List of support equipment and tools associated with computer systems" },
  { code: "C06", name: "List of software associated with computer systems" },
  { code: "C07", name: "Parts list associated with computer systems" },
  { code: "C13", name: "Notes" },
  { code: "C14", name: "Problem handling" },
  { code: "C15", name: "Summary of content" },
  { code: "C20", name: "System administration" },
  { code: "C21", name: "System monitoring" },
  { code: "C22", name: "Description of command" },
  { code: "C23", name: "Connect hardware" },
  { code: "C25", name: "System recovery" },
  { code: "C26", name: "Backup and restore" },
  { code: "C27", name: "Reboot" },
  { code: "C30", name: "Coordinate" },
  { code: "C31", name: "Defragmentation" },
  { code: "C32", name: "Input/Output media" },
  { code: "C33", name: "Disk mirroring" },
  { code: "C34", name: "Clear interference" },
  { code: "C35", name: "Time check" },
  { code: "C36", name: "Compatibility check" },
  { code: "C50", name: "Manage data" },
  { code: "C51", name: "Move data" },
  { code: "C52", name: "Manipulate/Use data" },
  { code: "C53", name: "Description of data storage" },
  { code: "C60", name: "Programming information" },
  { code: "C61", name: "Program flow chart" },
  { code: "C62", name: "Processing reference guide" },
  { code: "C70", name: "Security and privacy" },
  { code: "C72", name: "Security information" },
  { code: "C73", name: "Security procedures" },
  { code: "C74", name: "List of security/classification codes" },
  { code: "C75", name: "Access control" },
  { code: "C90", name: "Miscellaneous" },
  { code: "C91", name: "Quality assurance" },
  { code: "C92", name: "Vendor information" },
  { code: "C95", name: "Naming conventions" },
  { code: "C96", name: "Technical requirements" },
];

// Group info codes by category for easier browsing
export const INFO_CODE_CATEGORIES = [
  { label: "000-099 - General & Reference", range: [0, 99], prefix: "" },
  { label: "00x - Cross-reference & Repository", range: [], prefix: "00" },
  { label: "0Ax - Applicability & Warnings", range: [], prefix: "0A" },
  { label: "0Bx - Maintenance Planning", range: [], prefix: "0B" },
  { label: "100-199 - Operation", range: [100, 199], prefix: "" },
  { label: "200-299 - Servicing", range: [200, 299], prefix: "" },
  { label: "300-399 - Examinations & Tests", range: [300, 399], prefix: "" },
  { label: "400-499 - Fault Reports & Isolation", range: [400, 499], prefix: "" },
  { label: "500-599 - Disconnect, Remove & Disassemble", range: [500, 599], prefix: "" },
  { label: "600-699 - Repairs", range: [600, 699], prefix: "" },
  { label: "700-799 - Assemble, Install & Connect", range: [700, 799], prefix: "" },
  { label: "800-899 - Storage & Transportation", range: [800, 899], prefix: "" },
  { label: "900-999 - Miscellaneous", range: [900, 999], prefix: "" },
  { label: "C00-C99 - Computer Systems & Software", range: [], prefix: "C" },
];
